import { ComputedRef } from 'vue'

import { CommentaryPageStateViewModel } from '@/presentation/viewmodels/commentary/commentaryPageStateViewModel'
import { ConfigStateViewModel } from '@/presentation/viewmodels/config/configStateViewModel'
import { HistoryPageStateViewModel } from '@/presentation/viewmodels/history/historyPageStateViewModel'
import { JudgeDetailViewModel } from '@/presentation/viewmodels/judge/judgeDetailViewModel'
import { JudgeStateViewModel } from '@/presentation/viewmodels/judge/judgeStateViewModel'
import { JudgeDetailPageStateViewModel } from '@/presentation/viewmodels/judgeDetail/judgeDetailPageStateViewModel'
import { ProblemDescriptionViewModel } from '@/presentation/viewmodels/problem/problemDescriptionViewModel'
import { ProblemStateViewModel } from '@/presentation/viewmodels/problem/problemStateViewModel'
import { ProblemStatisticsViewModel } from '@/presentation/viewmodels/problem/problemStatisticsViewModel'
import { JudgeCaseViewModel } from '@/presentation/viewmodels/testCase/judgeCaseViewModel'
import { TestCaseViewModel } from '@/presentation/viewmodels/testCase/testCaseViewModel'

export class ProblemStatePresenter {
  private viewModel: ProblemStateViewModel
  private configStateViewModel: ConfigStateViewModel
  private testCaseViewModel: TestCaseViewModel
  private judgeCaseViewModel: JudgeCaseViewModel
  private judgeDetailViewModel: JudgeDetailViewModel
  private judgeStateViewModel: JudgeStateViewModel
  private judgeDetailPageStateViewModel: JudgeDetailPageStateViewModel
  private problemDescriptionViewModel: ProblemDescriptionViewModel
  private problemStatisticsViewModel: ProblemStatisticsViewModel
  private commentaryPageStateViewModel: CommentaryPageStateViewModel
  private historyPageStateViewModel: HistoryPageStateViewModel

  constructor(
    viewModel: ProblemStateViewModel,
    configStateViewModel: ConfigStateViewModel = new ConfigStateViewModel(),
    testCaseViewModel: TestCaseViewModel = new TestCaseViewModel(),
    judgeCaseViewModel: JudgeCaseViewModel = new JudgeCaseViewModel(),
    judgeDetailViewModel: JudgeDetailViewModel = new JudgeDetailViewModel(),
    judgeStateViewModel: JudgeStateViewModel = new JudgeStateViewModel(),
    judgeDetailPageStateViewModel: JudgeDetailPageStateViewModel = new JudgeDetailPageStateViewModel(),
    problemDescriptionViewModel: ProblemDescriptionViewModel = new ProblemDescriptionViewModel(),
    problemStatisticsViewModel: ProblemStatisticsViewModel = new ProblemStatisticsViewModel(),
    commentaryPageStateViewModel: CommentaryPageStateViewModel = new CommentaryPageStateViewModel(),
    historyPageStateViewModel: HistoryPageStateViewModel = new HistoryPageStateViewModel()
  ) {
    this.viewModel = viewModel
    this.configStateViewModel = configStateViewModel
    this.testCaseViewModel = testCaseViewModel
    this.judgeCaseViewModel = judgeCaseViewModel
    this.judgeDetailViewModel = judgeDetailViewModel
    this.judgeStateViewModel = judgeStateViewModel
    this.judgeDetailPageStateViewModel = judgeDetailPageStateViewModel
    this.problemDescriptionViewModel = problemDescriptionViewModel
    this.problemStatisticsViewModel = problemStatisticsViewModel
    this.commentaryPageStateViewModel = commentaryPageStateViewModel
    this.historyPageStateViewModel = historyPageStateViewModel
  }

  get problemId(): ComputedRef<string> {
    return this.viewModel.problemId
  }

  get nextProblemId(): ComputedRef<string> {
    return this.viewModel.nextProblemId
  }

  get prevProblemId(): ComputedRef<string> {
    return this.viewModel.prevProblemId
  }

  setProblemId(problemId: string): void {
    this.viewModel.setProblemId(problemId)
  }

  setNextProblemId(nextProblemId: string): void {
    this.viewModel.setNextProblemId(nextProblemId)
  }

  setPrevProblemId(prevProblemId: string): void {
    this.viewModel.setPrevProblemId(prevProblemId)
  }

  async changeProblem(problemId: string): Promise<void> {
    this.viewModel.setProblemId(problemId)
    this.setNextProblem(problemId)
    this.setPrevProblem(problemId)
    this.commentaryPageStateViewModel.initCommentaryPagesState()
    this.judgeDetailViewModel.removeJudgeDetails()
    this.historyPageStateViewModel.setIsFirstOpendPage(true)

    await this.problemDescriptionViewModel.getProblemDescription(
      this.configStateViewModel.displayLanguage.value,
      problemId
    )

    await this.problemStatisticsViewModel.getProblemStatistics(problemId)

    await this.testCaseViewModel.getTestCaseList(problemId)
    await this.judgeCaseViewModel.getJudgeCaseList(problemId)

    if (this.testCaseViewModel.testCaseList.value.length <= 0) {
      this.judgeStateViewModel.setTestInput('')
      this.judgeStateViewModel.setTestOutput('')
    } else {
      this.judgeStateViewModel.setTestInput(this.testCaseViewModel.testCaseList.value[0].in)
      this.judgeStateViewModel.setTestOutput(this.testCaseViewModel.testCaseList.value[0].out)
    }

    this.judgeDetailPageStateViewModel.setIsHideJudgeCaseList([])
    for (let i = 0; i < this.judgeCaseViewModel.judgeCaseList.value.length; i++) {
      this.judgeDetailPageStateViewModel.setFlagIsHideJudgeCaseList(i, false)
    }
  }

  //apiできたら不要

  private setNextProblem = (problemId: string) => {
    if (/^-?\d+$/.test(problemId)) {
      if (this.isNextChallengeLimit(Number(problemId))) {
        this.viewModel.setNextProblemId('-1')
      } else {
        this.viewModel.setNextProblemId(('0000' + String(Number(problemId) + 1)).slice(-4))
      }
    } else {
      if (problemId.includes('ITP') || problemId.includes('ALDS')) {
        this.viewModel.setNextProblemId(this.getNextITPALDS())
      } else {
        const nextCode = this.nextCourseList[problemId]
        if (nextCode == undefined || nextCode == null) {
          this.viewModel.setNextProblemId('-1')
        } else {
          this.viewModel.setNextProblemId(nextCode)
        }
      }
    }
  }

  setPrevProblem = (problemId: string) => {
    if (/^-?\d+$/.test(problemId)) {
      if (this.isPrevChallengeLimit(Number(problemId))) {
        this.viewModel.setPrevProblemId('-1')
      } else {
        this.viewModel.setPrevProblemId(('0000' + String(Number(problemId) - 1)).slice(-4))
      }
    } else {
      if (problemId.includes('ITP') || problemId.includes('ALDS')) {
        this.viewModel.setPrevProblemId(this.getPrevITPALDS())
      } else {
        const prevCode = this.prevCourseList[problemId]
        if (prevCode == undefined || prevCode == null) {
          this.viewModel.setPrevProblemId('-1')
        } else {
          this.viewModel.setPrevProblemId(prevCode)
        }
      }
    }
  }

  getNextITPALDS = () => {
    if (
      this.viewModel.problemId.value == 'ITP1_11_D' ||
      this.viewModel.problemId.value == 'ALDS1_15_D' ||
      this.viewModel.problemId.value == 'ITP2_11_D'
    ) {
      return '-1'
    } else if (this.viewModel.problemId.value == 'ALDS1_12_C') {
      return 'ALDS1_13_A'
    } else if (this.viewModel.problemId.value == 'ALDS1_13_C') {
      return 'ALDS1_14_A'
    }
    const code = this.viewModel.problemId.value.substring(
      this.viewModel.problemId.value.length - 1,
      this.viewModel.problemId.value.length
    )
    if (code == 'D') {
      let nextNumber = Number(
        this.viewModel.problemId.value.substring(
          this.viewModel.problemId.value.length - 3,
          this.viewModel.problemId.value.length - 2
        )
      )
      nextNumber = nextNumber == 9 ? 10 : nextNumber + 1
      return this.viewModel.problemId.value.substring(0, this.viewModel.problemId.value.length - 3) + nextNumber + '_A'
    } else {
      const nextCode = this.viewModel.problemId.value.charCodeAt(this.viewModel.problemId.value.length - 1) + 1
      return (
        this.viewModel.problemId.value.substring(0, this.viewModel.problemId.value.length - 1) +
        String.fromCharCode(nextCode)
      )
    }
  }

  isNextChallengeLimit = (id: number) => {
    if (
      id == 478 ||
      id == 694 ||
      id == 718 ||
      id == 1096 ||
      id == 1198 ||
      id == 1432 ||
      id == 1655 ||
      id == 2997 ||
      id == 3089 ||
      id == 3291 ||
      id == 3532
    ) {
      return true
    }
    return false
  }

  getPrevITPALDS = () => {
    if (
      this.viewModel.problemId.value == 'ITP1_1_A' ||
      this.viewModel.problemId.value == 'ALDS1_1_A' ||
      this.viewModel.problemId.value == 'ITP2_1_A'
    ) {
      return '-1'
    } else if (this.viewModel.problemId.value == 'ALDS1_13_A') {
      return 'ALDS1_12_C'
    } else if (this.viewModel.problemId.value == 'ALDS1_14_A') {
      return 'ALDS1_13_C'
    }
    const code = this.viewModel.problemId.value.substring(
      this.viewModel.problemId.value.length - 1,
      this.viewModel.problemId.value.length
    )
    if (code == 'A') {
      let prevNumber = Number(
        this.viewModel.problemId.value.substring(
          this.viewModel.problemId.value.length - 3,
          this.viewModel.problemId.value.length - 2
        )
      )
      prevNumber = prevNumber == 0 ? 9 : prevNumber - 1
      return (
        (prevNumber == 9
          ? this.viewModel.problemId.value.substring(0, this.viewModel.problemId.value.length - 4)
          : this.viewModel.problemId.value.substring(0, this.viewModel.problemId.value.length - 3)) +
        prevNumber +
        '_D'
      )
    } else {
      const prevCode = this.viewModel.problemId.value.charCodeAt(this.viewModel.problemId.value.length - 1) - 1
      return (
        this.viewModel.problemId.value.substring(0, this.viewModel.problemId.value.length - 1) +
        String.fromCharCode(prevCode)
      )
    }
  }

  isPrevChallengeLimit = (id: number) => {
    if (
      id == 500 ||
      id == 700 ||
      id == 800 ||
      id == 1100 ||
      id == 1200 ||
      id == 1500 ||
      id == 1700 ||
      id == 3000 ||
      id == 3100 ||
      id == 3300 ||
      id == 3600
    ) {
      return true
    }
    return false
  }

  nextCourseList: { [index: string]: string } = {
    DSL_1_A: 'DSL_1_B',
    DSL_1_B: 'DSL_2_A',
    DSL_2_A: 'DSL_2_B',
    DSL_2_B: 'DSL_2_C',
    DSL_2_C: 'DSL_2_D',
    DSL_2_D: 'DSL_2_E',
    DSL_2_E: 'DSL_2_F',
    DSL_2_F: 'DSL_2_G',
    DSL_2_G: 'DSL_2_H',
    DSL_2_H: 'DSL_2_I',
    DSL_2_I: 'DSL_3_A',
    DSL_3_A: 'DSL_3_B',
    DSL_3_B: 'DSL_3_C',
    DSL_3_C: 'DSL_3_D',
    DSL_3_D: 'DSL_4_A',
    DSL_4_A: 'DSL_5_A',
    DSL_5_A: 'DSL_5_B',
    DSL_5_B: '-1',
    GRL_1_A: 'GRL_1_B',
    GRL_1_B: 'GRL_1_C',
    GRL_1_C: 'GRL_2_A',
    GRL_2_A: 'GRL_2_B',
    GRL_2_B: 'GRL_3_A',
    GRL_3_A: 'GRL_3_B',
    GRL_3_B: 'GRL_3_C',
    GRL_3_C: 'GRL_4_A',
    GRL_4_A: 'GRL_4_B',
    GRL_4_B: 'GRL_5_A',
    GRL_5_A: 'GRL_5_B',
    GRL_5_B: 'GRL_5_C',
    GRL_5_C: 'GRL_5_D',
    GRL_5_D: 'GRL_5_E',
    GRL_5_E: 'GRL_6_A',
    GRL_6_A: 'GRL_6_B',
    GRL_6_B: 'GRL_7_A',
    GRL_7_A: '-1',
    CGL_1_A: 'CGL_1_B',
    CGL_1_B: 'CGL_1_C',
    CGL_1_C: 'CGL_2_A',
    CGL_2_A: 'CGL_2_B',
    CGL_2_B: 'CGL_2_C',
    CGL_2_C: 'CGL_2_D',
    CGL_2_D: 'CGL_3_A',
    CGL_3_A: 'CGL_3_B',
    CGL_3_B: 'CGL_3_C',
    CGL_3_C: 'CGL_4_A',
    CGL_4_A: 'CGL_4_B',
    CGL_4_B: 'CGL_4_C',
    CGL_4_C: 'CGL_5_A',
    CGL_5_A: 'CGL_6_A',
    CGL_6_A: 'CGL_7_A',
    CGL_7_A: 'CGL_7_B',
    CGL_7_B: 'CGL_7_C',
    CGL_7_C: 'CGL_7_D',
    CGL_7_D: 'CGL_7_E',
    CGL_7_E: 'CGL_7_F',
    CGL_7_F: 'CGL_7_G',
    CGL_7_G: 'CGL_7_H',
    CGL_7_H: 'CGL_7_I',
    CGL_7_I: '-1',
    DPL_1_A: 'DPL_1_B',
    DPL_1_B: 'DPL_1_C',
    DPL_1_C: 'DPL_1_D',
    DPL_1_D: 'DPL_1_E',
    DPL_1_E: 'DPL_1_F',
    DPL_1_F: 'DPL_1_G',
    DPL_1_G: 'DPL_1_H',
    DPL_1_H: 'DPL_1_I',
    DPL_1_I: 'DPL_2_A',
    DPL_2_A: 'DPL_2_B',
    DPL_2_B: 'DPL_2_C',
    DPL_2_C: 'DPL_3_A',
    DPL_3_A: 'DPL_3_B',
    DPL_3_B: 'DPL_3_C',
    DPL_3_C: 'DPL_4_A',
    DPL_4_A: 'DPL_4_B',
    DPL_4_B: 'DPL_5_A',
    DPL_5_A: 'DPL_5_B',
    DPL_5_B: 'DPL_5_C',
    DPL_5_C: 'DPL_5_D',
    DPL_5_D: 'DPL_5_E',
    DPL_5_E: 'DPL_5_F',
    DPL_5_F: 'DPL_5_G',
    DPL_5_G: 'DPL_5_H',
    DPL_5_H: 'DPL_5_I',
    DPL_5_I: 'DPL_5_J',
    DPL_5_J: 'DPL_5_K',
    DPL_5_K: 'DPL_5_L',
    DPL_5_L: '-1',
    NTL_1_A: 'NTL_1_B',
    NTL_1_B: 'NTL_1_C',
    NTL_1_C: 'NTL_1_D',
    NTL_1_D: 'NTL_1_E',
    NTL_1_E: 'NTL_2_A',
    NTL_2_A: 'NTL_2_B',
    NTL_2_B: 'NTL_2_C',
    NTL_2_C: 'NTL_2_D',
    NTL_2_D: 'NTL_2_E',
    NTL_2_E: 'NTL_2_F',
    NTL_2_F: '-1',
    INFO1_01_A: 'INFO1_01_B',
    INFO1_01_B: 'INFO1_01_C',
    INFO1_01_C: 'INFO1_01_D',
    INFO1_01_D: 'INFO1_01_E',
    INFO1_01_E: 'INFO1_02_A',
    INFO1_02_A: 'INFO1_02_B',
    INFO1_02_B: 'INFO1_02_C',
    INFO1_02_C: 'INFO1_02_D',
    INFO1_02_D: 'INFO1_03_A',
    INFO1_03_A: 'INFO1_03_B',
    INFO1_03_B: 'INFO1_03_C',
    INFO1_03_C: 'INFO1_03_D',
    INFO1_03_D: 'INFO1_03_E',
    INFO1_03_E: 'INFO1_04_A',
    INFO1_04_A: 'INFO1_04_B',
    INFO1_04_B: 'INFO1_04_C',
    INFO1_04_C: 'INFO1_04_D',
    INFO1_04_D: 'INFO1_04_E',
    INFO1_04_E: 'INFO1_04_F',
    INFO1_04_F: 'INFO1_04_G',
    INFO1_04_G: 'INFO1_04_H',
    INFO1_04_H: 'INFO1_04_I',
    INFO1_04_I: 'INFO1_05_A',
    INFO1_05_A: 'INFO1_05_B',
    INFO1_05_B: 'INFO1_05_C',
    INFO1_05_C: 'INFO1_05_D',
    INFO1_05_D: 'INFO1_05_E',
    INFO1_05_E: 'INFO1_06_A',
    INFO1_06_A: 'INFO1_06_B',
    INFO1_06_B: 'INFO1_06_C',
    INFO1_06_C: 'INFO1_06_D',
    INFO1_06_D: 'INFO1_06_E',
    INFO1_06_E: 'INFO1_06_F',
    INFO1_06_F: 'INFO1_07_A',
    INFO1_07_A: 'INFO1_07_B',
    INFO1_07_B: 'INFO1_07_C',
    INFO1_07_C: 'INFO1_07_D',
    INFO1_07_D: 'INFO1_07_E',
    INFO1_07_E: 'INFO1_07_F',
    INFO1_07_F: 'INFO1_08_A',
    INFO1_08_A: 'INFO1_08_B',
    INFO1_08_B: 'INFO1_08_C',
    INFO1_08_C: 'INFO1_08_D',
    INFO1_08_D: 'INFO1_08_E',
    INFO1_08_E: 'INFO1_08_F',
    INFO1_08_F: 'INFO1_08_G',
    INFO1_08_G: 'INFO1_08_H',
    INFO1_08_H: 'INFO1_09_A',
    INFO1_09_A: 'INFO1_09_B',
    INFO1_09_B: 'INFO1_09_C',
    INFO1_09_C: 'INFO1_09_D',
    INFO1_09_D: 'INFO1_09_E',
    INFO1_09_E: 'INFO1_09_F',
    INFO1_09_F: 'INFO1_10_A',
    INFO1_10_A: 'INFO1_10_B',
    INFO1_10_B: 'INFO1_10_C',
    INFO1_10_C: 'INFO1_10_D',
    INFO1_10_D: 'INFO1_10_E',
    INFO1_10_E: 'INFO1_10_F',
    INFO1_10_F: 'INFO1_10_G',
    INFO1_10_G: 'INFO1_10_H',
    INFO1_10_H: 'INFO1_11_A',
    INFO1_11_A: 'INFO1_11_B',
    INFO1_11_B: 'INFO1_11_C',
    INFO1_11_C: 'INFO1_11_D',
    INFO1_11_D: 'INFO1_11_E',
    INFO1_11_E: 'INFO1_11_F',
    INFO1_11_F: 'INFO1_12_A',
    INFO1_12_A: 'INFO1_12_B',
    INFO1_12_B: 'INFO1_12_C',
    INFO1_12_C: 'INFO1_12_D',
    INFO1_12_D: 'INFO1_12_E',
    INFO1_12_E: 'INFO1_13_A',
    INFO1_13_A: 'INFO1_13_B',
    INFO1_13_B: 'INFO1_13_C',
    INFO1_13_C: 'INFO1_13_D',
    INFO1_13_D: 'INFO1_13_E',
    INFO1_13_E: 'INFO1_13_F',
    INFO1_13_F: 'INFO1_13_G',
    INFO1_13_G: 'INFO1_14_A',
    INFO1_14_A: 'INFO1_14_B',
    INFO1_14_B: 'INFO1_14_C',
    INFO1_14_C: 'INFO1_14_D',
    INFO1_14_D: 'INFO1_14_E',
    INFO1_14_E: 'INFO1_14_F',
    INFO1_14_F: 'INFO1_14_G',
    INFO1_14_G: 'INFO1_15_A',
    INFO1_15_A: 'INFO1_15_B',
    INFO1_15_B: 'INFO1_15_C',
    INFO1_15_C: 'INFO1_15_D',
    INFO1_15_D: 'INFO1_15_E',
    INFO1_15_E: 'INFO1_15_F',
    INFO1_15_F: 'INFO1_15_G',
    INFO1_15_G: '-1'
  }

  prevCourseList: { [index: string]: string } = {
    DSL_1_A: '-1',
    DSL_1_B: 'DSL_1_A',
    DSL_2_A: 'DSL_1_B',
    DSL_2_B: 'DSL_2_A',
    DSL_2_C: 'DSL_2_B',
    DSL_2_D: 'DSL_2_C',
    DSL_2_E: 'DSL_2_D',
    DSL_2_F: 'DSL_2_E',
    DSL_2_G: 'DSL_2_F',
    DSL_2_H: 'DSL_2_G',
    DSL_2_I: 'DSL_2_H',
    DSL_3_A: 'DSL_2_I',
    DSL_3_B: 'DSL_3_A',
    DSL_3_C: 'DSL_3_B',
    DSL_3_D: 'DSL_3_C',
    DSL_4_A: 'DSL_3_D',
    DSL_5_A: 'DSL_4_A',
    DSL_5_B: 'DSL_5_A',
    GRL_1_A: '-1',
    GRL_1_B: 'GRL_1_A',
    GRL_1_C: 'GRL_1_B',
    GRL_2_A: 'GRL_1_C',
    GRL_2_B: 'GRL_2_A',
    GRL_3_A: 'GRL_2_B',
    GRL_3_B: 'GRL_3_A',
    GRL_3_C: 'GRL_3_B',
    GRL_4_A: 'GRL_3_C',
    GRL_4_B: 'GRL_4_A',
    GRL_5_A: 'GRL_4_B',
    GRL_5_B: 'GRL_5_A',
    GRL_5_C: 'GRL_5_B',
    GRL_5_D: 'GRL_5_C',
    GRL_5_E: 'GRL_6_D',
    GRL_6_A: 'GRL_5_E',
    GRL_6_B: 'GRL_6_A',
    GRL_7_A: 'GRL_6_B',
    CGL_1_A: '-1',
    CGL_1_B: 'CGL_1_A',
    CGL_1_C: 'CGL_1_B',
    CGL_2_A: 'CGL_1_C',
    CGL_2_B: 'CGL_2_A',
    CGL_2_C: 'CGL_2_B',
    CGL_2_D: 'CGL_2_C',
    CGL_3_A: 'CGL_2_D',
    CGL_3_B: 'CGL_3_A',
    CGL_3_C: 'CGL_3_B',
    CGL_4_A: 'CGL_3_C',
    CGL_4_B: 'CGL_4_A',
    CGL_4_C: 'CGL_4_B',
    CGL_5_A: 'CGL_4_C',
    CGL_6_A: 'CGL_5_A',
    CGL_7_A: 'CGL_6_A',
    CGL_7_B: 'CGL_7_A',
    CGL_7_C: 'CGL_7_B',
    CGL_7_D: 'CGL_7_C',
    CGL_7_E: 'CGL_7_D',
    CGL_7_F: 'CGL_7_E',
    CGL_7_G: 'CGL_7_F',
    CGL_7_H: 'CGL_7_G',
    CGL_7_I: 'CGL_7_H',
    DPL_1_A: '-1',
    DPL_1_B: 'DPL_1_A',
    DPL_1_C: 'DPL_1_B',
    DPL_1_D: 'DPL_1_C',
    DPL_1_E: 'DPL_1_D',
    DPL_1_F: 'DPL_1_E',
    DPL_1_G: 'DPL_1_F',
    DPL_1_H: 'DPL_1_G',
    DPL_1_I: 'DPL_1_H',
    DPL_2_A: 'DPL_1_I',
    DPL_2_B: 'DPL_2_A',
    DPL_2_C: 'DPL_2_B',
    DPL_3_A: 'DPL_2_C',
    DPL_3_B: 'DPL_3_A',
    DPL_3_C: 'DPL_3_B',
    DPL_4_A: 'DPL_3_C',
    DPL_4_B: 'DPL_4_A',
    DPL_5_A: 'DPL_4_B',
    DPL_5_B: 'DPL_5_A',
    DPL_5_C: 'DPL_5_B',
    DPL_5_D: 'DPL_5_C',
    DPL_5_E: 'DPL_5_D',
    DPL_5_F: 'DPL_5_E',
    DPL_5_G: 'DPL_5_F',
    DPL_5_H: 'DPL_5_G',
    DPL_5_I: 'DPL_5_H',
    DPL_5_J: 'DPL_5_I',
    DPL_5_K: 'DPL_5_J',
    DPL_5_L: 'DPL_5_K',
    NTL_1_A: '-1',
    NTL_1_B: 'NTL_1_A',
    NTL_1_C: 'NTL_1_B',
    NTL_1_D: 'NTL_1_C',
    NTL_1_E: 'NTL_1_D',
    NTL_2_A: 'NTL_1_E',
    NTL_2_B: 'NTL_2_A',
    NTL_2_C: 'NTL_2_B',
    NTL_2_D: 'NTL_2_C',
    NTL_2_E: 'NTL_2_D',
    NTL_2_F: 'NTL_2_E',
    INFO1_01_A: '-1',
    INFO1_01_B: 'INFO1_01_A',
    INFO1_01_C: 'INFO1_01_B',
    INFO1_01_D: 'INFO1_01_C',
    INFO1_01_E: 'INFO1_01_D',
    INFO1_02_A: 'INFO1_01_E',
    INFO1_02_B: 'INFO1_02_A',
    INFO1_02_C: 'INFO1_02_B',
    INFO1_02_D: 'INFO1_02_C',
    INFO1_03_A: 'INFO1_02_D',
    INFO1_03_B: 'INFO1_03_A',
    INFO1_03_C: 'INFO1_03_B',
    INFO1_03_D: 'INFO1_03_C',
    INFO1_03_E: 'INFO1_03_D',
    INFO1_04_A: 'INFO1_03_E',
    INFO1_04_B: 'INFO1_04_A',
    INFO1_04_C: 'INFO1_04_B',
    INFO1_04_D: 'INFO1_04_C',
    INFO1_04_E: 'INFO1_04_D',
    INFO1_04_F: 'INFO1_04_E',
    INFO1_04_G: 'INFO1_04_F',
    INFO1_04_H: 'INFO1_04_G',
    INFO1_04_I: 'INFO1_04_H',
    INFO1_05_A: 'INFO1_04_I',
    INFO1_05_B: 'INFO1_05_A',
    INFO1_05_C: 'INFO1_05_B',
    INFO1_05_D: 'INFO1_05_C',
    INFO1_05_E: 'INFO1_05_D',
    INFO1_06_A: 'INFO1_05_E',
    INFO1_06_B: 'INFO1_06_A',
    INFO1_06_C: 'INFO1_06_B',
    INFO1_06_D: 'INFO1_06_C',
    INFO1_06_E: 'INFO1_06_D',
    INFO1_06_F: 'INFO1_06_E',
    INFO1_07_A: 'INFO1_06_F',
    INFO1_07_B: 'INFO1_07_A',
    INFO1_07_C: 'INFO1_07_B',
    INFO1_07_D: 'INFO1_07_C',
    INFO1_07_E: 'INFO1_07_D',
    INFO1_07_F: 'INFO1_07_E',
    INFO1_08_A: 'INFO1_07_F',
    INFO1_08_B: 'INFO1_08_A',
    INFO1_08_C: 'INFO1_08_B',
    INFO1_08_D: 'INFO1_08_C',
    INFO1_08_E: 'INFO1_08_D',
    INFO1_08_F: 'INFO1_08_E',
    INFO1_08_G: 'INFO1_08_F',
    INFO1_08_H: 'INFO1_08_G',
    INFO1_09_A: 'INFO1_08_H',
    INFO1_09_B: 'INFO1_09_A',
    INFO1_09_C: 'INFO1_09_B',
    INFO1_09_D: 'INFO1_09_C',
    INFO1_09_E: 'INFO1_09_D',
    INFO1_09_F: 'INFO1_09_E',
    INFO1_10_A: 'INFO1_09_F',
    INFO1_10_B: 'INFO1_10_A',
    INFO1_10_C: 'INFO1_10_B',
    INFO1_10_D: 'INFO1_10_C',
    INFO1_10_E: 'INFO1_10_D',
    INFO1_10_F: 'INFO1_10_E',
    INFO1_10_G: 'INFO1_10_F',
    INFO1_10_H: 'INFO1_10_G',
    INFO1_11_A: 'INFO1_10_H',
    INFO1_11_B: 'INFO1_11_A',
    INFO1_11_C: 'INFO1_11_B',
    INFO1_11_D: 'INFO1_11_C',
    INFO1_11_E: 'INFO1_11_D',
    INFO1_11_F: 'INFO1_11_E',
    INFO1_12_A: 'INFO1_11_F',
    INFO1_12_B: 'INFO1_12_A',
    INFO1_12_C: 'INFO1_12_B',
    INFO1_12_D: 'INFO1_12_C',
    INFO1_12_E: 'INFO1_12_D',
    INFO1_13_A: 'INFO1_12_E',
    INFO1_13_B: 'INFO1_13_A',
    INFO1_13_C: 'INFO1_13_B',
    INFO1_13_D: 'INFO1_13_C',
    INFO1_13_E: 'INFO1_13_D',
    INFO1_13_F: 'INFO1_13_E',
    INFO1_13_G: 'INFO1_13_F',
    INFO1_14_A: 'INFO1_13_G',
    INFO1_14_B: 'INFO1_14_A',
    INFO1_14_C: 'INFO1_14_B',
    INFO1_14_D: 'INFO1_14_C',
    INFO1_14_E: 'INFO1_14_D',
    INFO1_14_F: 'INFO1_14_E',
    INFO1_14_G: 'INFO1_14_F',
    INFO1_15_A: 'INFO1_14_G',
    INFO1_15_B: 'INFO1_15_A',
    INFO1_15_C: 'INFO1_15_B',
    INFO1_15_D: 'INFO1_15_C',
    INFO1_15_E: 'INFO1_15_D',
    INFO1_15_F: 'INFO1_15_E',
    INFO1_15_G: 'INFO1_15_F'
  }
}
